function getCurrentDate() {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // 월은 0부터 시작하므로 1을 더하고, 두 자리로 맞춥니다.
  const day = String(currentDate.getDate()).padStart(2, "0"); // 두 자리로 맞춥니다.

  // 날짜를 문자열로 반환합니다.
  const currentDateFormatted = `${year}.${month}.${day}`;

  return currentDateFormatted;
}

export { getCurrentDate };
